<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: AboutPage                                             |
| Section: views/info                                              |
| Purpose: About route describing project background and goals.    |
+------------------------------------------------------------------+
-->
<template>
    <div class="AboutPage_wrapper wrapper">
        <div class="header">
            <h1>{{ $t('aboutPage.title') }}</h1>
            <p class="subtitle">{{ $t('aboutPage.subtitle') }}</p>
        </div>
        <StoryCard :imageSrc="imageSrc3" :cover="true">
            <h2>{{ $t('aboutPage.section1.heading') }}</h2>
            <p>{{ $t('aboutPage.section1.p1') }}</p>
            <p
                v-html="$t('aboutPage.section1.p2', { charlesHref: localePath('/person/I1'), angelineHref: localePath('/person/I2') })">
            </p>
            <p>{{ $t('aboutPage.section1.p3') }}</p>
            <p>{{ $t('aboutPage.section1.p4') }}</p>
        </StoryCard>

        <!-- <StoryCard :imageSrc="imageSrc3" :reverse="true" :cover="true">
            <h2>Een reis naar het verleden</h2>
            <p>Sejarah Thümann begon met een simpele, maar diepgewortelde nieuwsgierigheid: wie waren mijn grootouders,
                en wat is het verhaal achter mijn Nederlands-Indische roots? Van kleins af aan hoorde ik verhalen over
                mijn opa, geboren in Kediri, en mijn oma, geboren in Soerabaja. Toch stond ik daar niet bewust bij stil,
                tot 2015, toen ik het besef kreeg van mijn eigen Nederlands-Indische identiteit.</p>
            <p>Mijn opa en oma heb ik nooit gekend; ze overleden kort na elkaar, nog voordat ik één maand oud was. Als
                ik vragen stelde over hun verleden, kon mijn vader daar weinig over vertellen. Opa en oma zwegen vroeger
                veel over hun leven in Nederlands-Indië en over de reis naar het Hollandse vasteland in 1951. "We zijn
                nu in Holland, dus we gedragen ons Hollands," zeiden ze altijd. Het Indische verleden werd weggemoffeld,
                en met hen verdwenen ook de verhalen.</p>
            <p>Maar de vragen bleven, en ik wilde antwoorden. Mijn zoektocht begon bij archieven zoals het Nationaal
                Archief, en wat ik ontdekte, veranderde alles. Ik leerde dat mijn opa in het Koninklijk
                Nederlands-Indisch Leger had gediend en over de drie broers die hij verloor tijdens de Tweede
                Wereldoorlog in Azië en de daaropvolgende Indonesische Onafhankelijkheidsoorlog. Ik ontdekte meer over
                zijn Molukse moeder en zijn Elzasser grootvader, die in 1877 de oversteek maakte naar de Oost. Van mijn
                oma ontdekte ik dat ze, naast haar zusje en twee broertjes, nog een groot aantal halfzusjes en
                halfbroertjes had. Ook leerde ik over het tragische lot van haar vader, die de dwangarbeid aan de
                Birma-dodenspoorlijn niet overleefde. Wat begon als een kleine zoektocht groeide uit tot een uitgebreide
                stamboom met meer dan 3.200 familieleden, 2.500 bewijsstukken, 1.000 foto’s en zeven biografieën over
                mijn (over)grootouders.</p>
        </StoryCard> -->

        <StoryCard :imageSrc="imageSrc2" :reverse="true" :cover="true">
            <h2>{{ $t('aboutPage.section2.heading') }}</h2>
            <p>{{ $t('aboutPage.section2.p1') }}</p>
            <blockquote>
                {{ $t('aboutPage.section2.blockquote') }}
            </blockquote>
            <p>{{ $t('aboutPage.section2.p2') }}</p>
        </StoryCard>
    </div>
    <!-- <div class="PersonCardGroup_container">
        <div class="PersonCardGroup_wrapper wrapper">
            <h2>Een reis naar het verleden</h2>
            <p>Sejarah Thümann begon met een simpele, maar diepgewortelde nieuwsgierigheid: wie waren mijn grootouders,
                en wat is het verhaal achter mijn Nederlands-Indische roots? Van kleins af aan hoorde ik verhalen over
                mijn opa, geboren in Kediri, en mijn oma, geboren in Soerabaja. Toch stond ik daar niet bewust bij stil,
                tot 2015, toen ik het besef kreeg van mijn eigen Nederlands-Indische identiteit.</p>
            <p>Mijn opa en oma heb ik nooit gekend; ze overleden kort na elkaar, nog voordat ik één maand oud was. Als
                ik vragen stelde over hun verleden, kon mijn vader daar weinig over vertellen. Opa en oma zwegen vroeger
                veel over hun leven in Nederlands-Indië en over de reis naar het Hollandse vasteland in 1951. "We zijn
                nu in Holland, dus we gedragen ons Hollands," zeiden ze altijd. Het Indische verleden werd weggemoffeld,
                en met hen verdwenen ook de verhalen.</p>
            <p>Maar de vragen bleven, en ik wilde antwoorden. Mijn zoektocht begon bij archieven zoals het Nationaal
                Archief, en wat ik ontdekte, veranderde alles. Ik leerde dat mijn opa in het Koninklijk
                Nederlands-Indisch Leger had gediend en over de drie broers die hij verloor tijdens de Tweede
                Wereldoorlog in Azië en de daaropvolgende Indonesische Onafhankelijkheidsoorlog. Ik ontdekte meer over
                zijn Molukse moeder en zijn Elzasser grootvader, die in 1877 de oversteek maakte naar de Oost. Van mijn
                oma ontdekte ik dat ze, naast haar zusje en twee broertjes, nog een groot aantal halfzusjes en
                halfbroertjes had. Ook leerde ik over het tragische lot van haar vader, die de dwangarbeid aan de
                Birma-dodenspoorlijn niet overleefde. Wat begon als een kleine zoektocht groeide uit tot een uitgebreide
                stamboom met meer dan 3.200 familieleden, 2.500 bewijsstukken, 1.000 foto’s en zeven biografieën over
                mijn (over)grootouders.</p>
            <img class="decoration decoration_top_right--offset" src="@/assets/decorations/batu-nisan.svg">
        </div>
        <div class="StatBar_container">
            <StatBar />
        </div>
    </div> -->

    <ContactCta />

    <!-- <div class="PersonCardGroup_container">
        <div class="PersonCardGroup_wrapper wrapper">
            <h2>Met dank aan familie en vrienden</h2>
            <p>Dit project is mogelijk gemaakt door de hulp en steun van vele mensen. Van familieleden die verhalen,
                foto’s en documenten hebben gedeeld, tot onderzoekers en vrienden die me hebben geholpen bij het vinden
                van antwoorden. Samen zorgen we ervoor dat deze verhalen niet vergeten worden.</p>
        </div>
    </div> -->
    <!-- <div class="AboutPage_wrapper wrapper">
        <StoryCard :imageSrc="imageSrc3" :contactForm="true" :cover="true" />
    </div> -->
</template>

<script>
import StoryCard from '@/components/StoryCard.vue';
import ContactCta from '@/components/ContactCta.vue';
// import StatBar from '@/components/StatBar.vue';
import { applyGenericSeo, applyBreadcrumbSeo } from '@/utils/seoUtils';
import { useLocale } from '@/composables/useLocale';

const imageSrc1 = require('@/assets/jeffreythumann-13.png');
const imageSrc2 = require('@/assets/graf-van-opa-en-oma.jpg');
const imageSrc3 = require('@/assets/jeffreythumann-8.jpg');

export default {
    name: "ContactPage",
    components: {
        StoryCard,
        ContactCta,
        // StatBar
    },
    setup() {
        const { localePath } = useLocale();
        return { localePath };
    },
    data() {
        return {
            imageSrc1,
            imageSrc2,
            imageSrc3
        };
    },
    mounted() {
        const title = this.$t('aboutPage.seoTitle');
        const description = this.$t('aboutPage.seoDescription');
        const image = "https://sejarah-thumann.online/img/sejarah_thumann1080x781.4fc54a6a.jpg";
        const url = window.location.href;

        applyGenericSeo({ title, description, image, url }, { includeTwitter: true });
        applyBreadcrumbSeo([
            { name: this.$t('nav.home'), url: `https://sejarah-thumann.online${this.localePath('/')}` },
            { name: this.$t('aboutPage.title'), url: `https://sejarah-thumann.online${this.localePath('/over')}` }
        ]);
    },
}
</script>

<style scoped>
.AboutPage_wrapper {
    padding: var(--page-padding);
    min-height: calc(100vh - 106px - 516px);
    display: flex;
    flex-direction: column;
    gap: 72px;
}

h1,
.header p {
    text-align: center;
}

.subtitle {
    margin-top: 16px;
    margin-bottom: 0;
}

a:not(.BtnPrimary, .BtnPrimary a) {
    display: inline;
    font-weight: 600;
    color: var(--brand-color-1);
}

a:hover {
    text-decoration: underline;
}

.PersonCardGroup_wrapper h2,
.PersonCardGroup_wrapper p {
    color: var(--brand-text-light);
}

.StatBar_container {
    background:
        url('@/assets/noise128x128.png'),
        linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, var(--brand-bg-2) 50%);
    background-repeat: repeat;
    background-size: auto;
}

@media (max-width: 860px) {
    .AboutPage_wrapper {
        padding: var(--page-padding-mobile);
        gap: 72px;
    }

    .PersonCardGroup_wrapper {
        padding: var(--page-padding-mobile);
    }

    .decoration_top_right--offset {
        display: none;
    }

    .StatBar_container {
        background: var(--brand-bg-2);
        padding-top: 72px;
    }
}
</style>
